



















































import { Component, Mixins, Prop } from "vue-property-decorator";
import { AuthenticationMixin } from "./mixins";
import { DomainRegistry } from "../../domain";
import { ImelessTextarea } from "../system";
import { BrowserUtility, BrowserKinds } from "../../utilities";
import { Department, DepartmentGroup } from "../../domain/department";

@Component({
  components: {
    ImelessTextarea,
  },
})
export default class LoginView extends Mixins(AuthenticationMixin) {
  @Prop()
  departmentCode: string;

  @Prop()
  hostName: string;

  @Prop()
  // Configurationで同名の変数を使用している為、RoutesFactoryから受け取るパラメータのプロパティ名を変更している
  shouldSelectDepartmentManually: boolean;

  @Prop()
  departmentGroupCode: string;

  @Prop()
  referenceableDepartmentGroupCodes: string[];
  
  data(): any {
    return {
      isCreated: false,
      departmentId: this.departmentCode
    };
  }
  isCreated: boolean;
  departmentId: string;

  $refs!: {
    passwordImelessTextarea: ImelessTextarea,
    passwordInput: HTMLInputElement,
  };

  get isProcessing(): boolean {
    return !this.isCreated
        || this.isAuthenticating;
  }

  get isCloseEnable(): boolean {
    return this.$configuration.behavior.closer.isEnable && this.$store.getters.isManualCloseable !== false;
  }

  get shouldSelectDepartment(): boolean {
    // パラメータで同名の変数を使用しており、パラメータ側の変数名をshouldSelectDepartmentManuallyへ変更している
    return this.$configuration.behavior.authentication.login.shouldSelectDepartment;
  }

  get shouldUseImelessTextarea(): boolean {
    return (BrowserUtility.getBrowserKind() !== BrowserKinds.InternetExplorer)
        && !BrowserUtility.isMobile();
  }

  created() {
    if (this.id && (this.id !== "")) {
      this.authenticateAutomatically(this.id);
    }
    this.isCreated = true;
  }

  private authenticateAutomatically(id: string): void {
    this.$logger.info("ログイン処理を開始します。");
    this.loginAutomatically(id, this.departmentId, this.hostName, this.orderUserId, this.attendingUserId, this.departmentGroupCode, this.referenceableDepartmentGroupCodes)
      .then(this.handleAuthenticationSucceeded)
      .catch(e => {
        if (e && e.response && e.response.status === 504) {
          this.handleAuthenticationFailed(
            e,
            "自動ログイン失敗",
            "サーバーとの通信に失敗しました。",
          );
        } else {
          this.handleAuthenticationFailed(
            e,
            "自動ログイン失敗",
            "自動ログイン失敗しました。" + this.toExceptionMessage(e),
          );
        }
      }
    );
  }

  authenticate(): void {
    if (this.isAuthenticating) { return; }
    // TODO: 指示者ありのときの対応
    this.login(this.id, this.password, this.departmentId, this.hostName, this.departmentGroupCode, this.referenceableDepartmentGroupCodes)
      .then(() => {
        let hasError = false;
        if (this.isSpecifiedDepartmentLoginFailed()) {
          hasError = true;
          this.$error(
            "診療科",
            "指定された診療科でログインできませんでした。",
          );
        }
        if (this.isSpecifiedOrderUserLoginFailed()) {
          hasError = true;
          this.$error(
            "指示者",
            "指定された指示者情報を付与してログインできませんでした。"
          );
        }
        if (this.isSpecifiedAttendingUserLoginFailed()) {
          hasError = true;
          this.$error(
            "指導者",
            "指定された指導者情報を付与してログインできませんでした。"
          );
        }
        if (!hasError) {
          this.$success(
            "ログイン成功",
            "ログインしました。",
          );
        }
        (this.$el as HTMLElement).focus(); // IEで入力項目にフォーカスが当たったまま遷移した場合、上記カードが消えるまで押せなくなる問題の対応
        this.handleAuthenticationSucceeded();
      })
      .catch(e => {
        this.handleAuthenticationFailed(
          e,
          "ログイン失敗",
          "ログイン失敗しました。ログインIDとパスワードを確認してください。",
        );
      }
    );
  }

  private isSpecifiedDepartmentLoginFailed(): boolean {
    if (!this.departmentId) { return false; }
    if (!this.$store.getters.department) { return true; }
    return this.departmentId !== this.$store.getters.department.id;
  }

  private isSpecifiedOrderUserLoginFailed(): boolean {
    if (!this.orderUserId) { return false; }
    if (!this.$store.getters.orderUser) { return true; }
    return this.orderUserId.toUpperCase() !== this.$store.getters.orderUser.id.toUpperCase();
  }

  private isSpecifiedAttendingUserLoginFailed(): boolean {
    if (!this.attendingUserId) { return false; }
    if (!this.$store.getters.attendingUser) { return true; }
    return this.attendingUserId.toUpperCase() !== this.$store.getters.attendingUser.id.toUpperCase();
  }

  private async handleAuthenticationSucceeded(): Promise<void> {
    if (this.shouldSelectDepartment) {
      await this.selectLoginDepartment();
    }
    await this.fillDepartmentGroup();
    const destination = this.queryParameterToFirstString(this.$route.query.redirect);
    this.$router.replace(destination ? destination : "/", () => {}, (e) => !!e ? console.error(e) : {});
  }

  get shouldOpenDepartmentButtonSelectorDialog(): boolean {
    return !this.$store.getters.department
        || (this.shouldSelectDepartmentManually && !this.departmentCode);
  }

  async selectLoginDepartment(): Promise<void> {
    if (!this.shouldOpenDepartmentButtonSelectorDialog) { return; }

    const condition = {
      name: "ログイン" + this.$wording.common.department,
      isCancelable: false,
      isUserDepartmentsOnly: true,
    };
    await this.$commonDialogs.department.buttonSelector.selectOptionConditionally(condition, null)
      .then(d => {
        if (d !== undefined) {
          this.$store.commit("setDepartment", d);
        }
        if (d) {
          DomainRegistry.department.getDepartmentRepository().saveSelectedDepartment(this.$store.getters.user.id, d.id);
        }
      })
      .catch(e => {
        this.$error(
          "ログイン" + this.$wording.common.department + "選択失敗",
          "ログイン" + this.$wording.common.department + "選択中にエラーが発生しました。",
          e,
        );
      });
  }

  private async fillDepartmentGroup(): Promise<void> {
    if (!!this.$store.getters.departmentGroup) { return; }
    if (this.departmentGroupCode) {
      // 基本的にはここは通らないはず
      const departmentGroup = await this.getDepartmentGroup(this.departmentGroupCode);
      this.setDepartmentGroupToStore(departmentGroup);
    } else if (this.$configuration.behavior.authentication.login.shouldSelectDepartmentGroupByLoginDepartmentAutomatically) {
      const departmentGroup = await this.getDepartmentRelatedDepartmentGroup(this.$store.getters.department as Department);
      this.setDepartmentGroupToStore(departmentGroup);
    }
  }

  private setDepartmentGroupToStore(departmentGroup: DepartmentGroup): void {
    this.$store.commit("setDepartmentGroup", departmentGroup);
  }

  private queryParameterToFirstString(value: string | (string | null)[]): string {
    return Array.isArray(value)
      ? ((0 < value.length) ? value[0] : null)
      : value;
  }

  private handleAuthenticationFailed(error: Error, title: string, message: string): void {
    this.password = "";
    this.$error(
      title,
      message,
      error,
    );
  }

  close(): void {
    this.$closeWindow();
  }

  focusToPassword(): void {
    if (this.shouldUseImelessTextarea) {
      this.$refs.passwordImelessTextarea.getEditor().focus();
    } else {
      this.$refs.passwordInput.focus();
    }
  }
}
